import cn from 'classnames';
import React, { forwardRef } from 'react';
import Img from '../Img';
import './style.scss';

interface IconButtonProps {
  icSrc: string;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  id?: string;
}
const IconButton = forwardRef<HTMLImageElement, IconButtonProps>((props, ref) => {
  const { className, icSrc, onClick, ...anotherProps } = props;
  const customClass = cn('icon-button', {
    [className || '']: className,
  });
  return <Img src={icSrc} className={customClass} onClick={onClick} ref={ref} {...anotherProps} alt="icButton" />;
});

export default IconButton;
